<script setup lang="ts">
const { variant = 'regular' } = defineProps<{ variant?: 'compact' | 'regular' }>()

let lineCount = Math.floor(Math.random() * 3) + 1

const lineLengths = Array(lineCount)
  .fill(0)
  .map(() => Math.floor(Math.random() * 200) + 100)
</script>

<template>
  <li :class="[$style.root, { [$style.rootVariantCompact]: variant === 'compact' }]">
    <div :class="$style.content">
      <div :class="$style.avatarWrap">
        <div :class="[$style.avatar, { [$style.avatarVariantCompact]: variant === 'compact' }]" />
      </div>

      <div :class="$style.main">
        <div :class="[$style.header, { [$style.headerVariantCompact]: variant === 'compact' }]" />
        <div :class="$style.body">
          <div
            v-for="lineLength in lineLengths"
            :class="[$style.line, { [$style.lineVariantCompact]: variant === 'compact' }]"
            :style="{ maxWidth: lineLength + 'px' }"
          />
        </div>
      </div>
    </div>
    <div :class="$style.separator" />
  </li>
</template>

<style lang="scss" module>
.root {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1a1920;
  }

  &:last-child {
    .separator {
      display: none;
    }
  }
}

.rootVariantCompact {
  padding: 0 10px;
}

.content {
  display: flex;
  gap: 10px;
}

.avatarWrap {
  padding: 10px 0;
  width: fit-content;
  flex-shrink: 0;
}

@keyframes pulse {
  0% {
    background-color: #7a7a7a80;
  }
  50% {
    background-color: #7a7a7a40;
  }
  100% {
    background-color: #7a7a7a80;
  }
}

.avatar {
  animation: pulse 1.5s ease-in-out infinite;
  background-color: #7a7a7a80;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.avatarVariantCompact {
  width: 30px;
  height: 30px;
}

.main {
  flex-grow: 1;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.header {
  animation: pulse 1.5s ease-in-out infinite;
  background-color: #7a7a7a80;
  border-radius: 2px;
  width: 100%;
  max-width: 200px;
  height: 15px;
}

.headerVariantCompact {
  height: 13px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.line {
  animation: pulse 1.5s ease-in-out infinite;
  background-color: #7a7a7a80;
  border-radius: 2px;
  width: 100%;
  height: 15px;
}

.lineVariantCompact {
  height: 13px;
}

.separator {
  height: 1px;
  background-color: #474756;
  width: 100%;
}

.header {
  display: flex;
  align-items: first baseline;
  gap: 5px;
}
</style>
